import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import 'font-awesome/css/font-awesome.min.css';
import { toast } from 'react-toastify';
import loadProductOptions from "../../../services/loaddata/loadProducts";
import { AsyncPaginate } from "react-select-async-paginate";

const ProductEditor = forwardRef((props, ref) => {


    const [selectedVal, setSelectedVal] = useState(props.value);
    const [editing, setEditing] = useState(true);
    const refContainer = useRef(null);
    const [editNew, setEditNew] = useState(false);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        focus();
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return selectedVal != null ? selectedVal : props.value;
            },

            isPopup() {
                return true;
            }
        };
    });

    useEffect(() => {
        if (!editing) {
            props.api.stopEditing();
        }
    }, [editing]);

    const focus = () => {
        window.setTimeout(() => {
            let container = ReactDOM.findDOMNode(refContainer.current);
            if (container) {
                container.focus();
            }
        });
    };


    const onSelectChange = (val, action) => {
        setSelectedVal(val);
        setTimeout(function () {
            props.api.stopEditing();
            if (!editNew) {
                props.node.setDataValue("product", val);
            }
        })
    }
    const onMouseOver = e => {
        let container = ReactDOM.findDOMNode(e.target).parentNode.getElementsByTagName("input")[0];
        if (container != undefined) {
            container.focus();
        }
    }
    const onInputChange = (val, action) => {
        if (val.length > 220) {
            toast.dismiss();
            if (!toast.isActive()) {
                toast.error(t("Error on length. Max length is 220 characters"))
            }

            return
        }
        if (val != "") {
            setEditNew(true);
        }

        if (action.action == "input-change") {
            var _pro = props.node.data.product;
            var _vat = props.node.data.vat;
            var vat = { id: "VAT_24", value: 24 };
            var quantity = props.node.data.quantity;
            if (_vat) {
                vat = {
                    id: _vat.value,
                    value: _vat.label
                };
            }
            else if (_pro.model && _pro.model.vat) {
                vat = _pro.model.vat;
            }

            var price = 0;
            if (props.node.data.unitPrice) {
                price = props.node.data.unitPrice;
            }
            else if (_pro.model && _pro.model.price) {
                price = _pro.model.price;
            }


            var model = {
                value: val,
                label: val,
                measurementUnit: _pro.model ? (_pro.model.measurementUnit ? _pro.model.measurementUnit : "PIECES") : "PIECES",
                vat: vat,
                price: price,
            }



            setSelectedVal({
                value: val,
                label: val,
                model: model
            })
            if (props.node.data.quantity) {
                setTimeout(function () {
                    props.node.setDataValue("quantity", quantity);
                }, 300)

            }
        }
    }


    const loadProductsPageOptions = async (q, prevOptions, { page }) => {
        const { options, hasMore } = await loadProductOptions(q, page);
        return {
            options,
            hasMore,

            additional: {
                page: page + 1
            }
        };
    };
    const defaultAdditional = {
        page: 1
    };

    const onKeyDown = (e) => {
        if (e.keyCode === 13) {
            e.stopPropagation();
            props.api.stopEditing();
        }
    }


    return (<div style={{ width: props.column.actualWidth + 'px' }}>

        <span onMouseOver={onMouseOver} ref={refContainer} className="selectCell">
            <AsyncPaginate
                inputId="product_select"
                inputProps={{ autoComplete: 'nope' }}
                autosize={true}
                onKeyDown={onKeyDown}
                defaultValue={selectedVal ? (selectedVal.label ? selectedVal : null) : null}
                menuIsOpen={true}
                onChange={onSelectChange}
                onChangeValue={onSelectChange}
                maxMenuHeight={200}
                onInputChange={onInputChange}
                placeholder={t('placeholderSelectCT')}
                inputValue={selectedVal ? selectedVal.label : null}
                loadOptionsOnMenuOpen={true}
                additional={defaultAdditional}
                // isClearable={true}
                loadOptions={loadProductsPageOptions}
            >
            </AsyncPaginate>
        </span>
    </div>
    );
});

export default ProductEditor